<template>
<div class="workflow-child">
    <!--     <div class="report-image-grid" v-if="hops3DRelated && hops3DRelated.length>0">

            <div class="card-grid-item" :style="'background-image: url({{hop.image_preview_url}}}); height: 400px; width: 400px;'" v-for="hop in hops3DRelated" :hop="hop" :key="hop._id">
                <h3 class="search-listing-title"><a class="search-candidate-title" @click="$emit('report-event',{'topic': 'hop-selected', 'hop':hop})"><i class="search-listing-icon fa fa-cloud"></i> <span>{{hop['title']}}</span></a></h3>
                <div class="search-listing-body">{{hop['description']}}</div>

                <div class="search-listing-footer">
                    <a class="search-candidate-link"  data-bind="visible: point, click: mapLinkClicked" style="display: none;"><i class="fa fa-map-marker"></i> Nuvola </a>
                    <a class="search-candidate-link pull-right"  @click="$emit('report-event',{'topic': 'hop-selected', 'hop':hop})"><i class="fa fa-check-circle"></i>  Seleziona</a>
                </div>
            </div>

    </div> -->
    <div v-if="hops3DRelated && hops3DRelated.length>0">
            <!-- <div class="rp-report-related-resource-item" v-for="hop in hops3DRelated" @click="$emit('selected',hop)" :hop="hop" :key="hop._id">
                <dt>
                    <a  style="font-weight: bold" @click="$emit('selected',hop)">{{hop.tiles[0]['data']['51201dd6-6afd-11ea-8a06-08002713135a']}}</a>
                    <a  @click="$emit('selected',hop)">{{hop.tiles[0]['data']['8f40f5ec-6afb-11ea-8a06-08002713135a']}}</a>
                </dt>
                <a  @click="$emit('selected',hop)">
                    <img class="report-related-resource-thumbnail" :src="hop.tiles[0]['data']['9e6c4ac6-6afb-11ea-8a06-08002713135a'][0]['url']">
                </a>    
            </div> -->
            <div class="col-sm-3" v-for="hop in hops3DRelated" @click="$emit('report-event',{'topic': 'hop-selected', 'hop':hop})" :hop="hop" :key="hop.id">
                <div class="container-element">
                    <div  class="tag">
                        <span>{{hop["title"]}}</span>
                    </div>
                    <img style="width:200px;height:200px;" class="report-related-resource-thumbnail" :src="hop.image_preview_url?hop.image_preview_url:'/media/img/not-available.png'">
                    <!-- <div class="panel-body">
                        {{hop.description}}
                    </div> -->
                </div>
            </div>

    </div>
    <div class="card-grid-item report-modal" v-else>
      <div class="block">
        <h3 class="circle">
          Nessun risultato
        </h3>
      </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Hop3DSelect',
    props: {
        hops3DRelated: {
            type: Array,
            value: []
        }
    },
    methods: {

    }

}
</script>

<style scoped>
    .panel {
        width: 240px;
    }
    .panel-body {
        font-size: 10px;
        text-align: left;
    }
    .container-element {
       border: 1px solid #DDDDDD;
       width: 200px;
       height: 200px;
       position: relative;
    }
    .tag {
       float: left;
       position: absolute;
       left: 0px;
       top: 0px;
       z-index: 1000;
       background-color: rgba(0,0,0,0.3);
       padding: 5px;
       color: #FFFFFF;
       font-weight: bold;
       text-align: left;
    }

    #app .card-grid-item.report-modal {
        min-height: 240px;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        text-align: center;
        display: table;
        width: 100%;
        border: 0px;
        }

    #app .block {
        display: table-cell;
        vertical-align: middle;
        background-color: #ebeef0;
        }
</style>